import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';

import { SocialButtonVariantEnum } from '~/component/social-button/enums/variant.enum';

import { SocialButtonConfigInterface } from './interfaces/social-button.config.interface';

@Component({
  selector: 'app-social-buttons',
  templateUrl: './social-buttons.component.html',
  styleUrls: ['./social-buttons.component.scss'],
})
export class SocialButtonsComponent {
  @Input() public buttonsConfig: SocialButtonConfigInterface[] = [];
  @Input() public description?: string;
  @Input() public variant = SocialButtonVariantEnum.Primary;

  @Output() public readonly selectSocialButton = new EventEmitter<string>();

  constructor(private readonly _clipboardService: ClipboardService) {}

  public get className(): string {
    const classes = ['social-buttons', `social-buttons--${this.variant}`];

    return classes.join(' ');
  }

  public get isInlineVariant(): boolean {
    return this.variant === SocialButtonVariantEnum.Inline;
  }

  public copyLink(activityUrl: string): void {
    this._clipboardService.copy(activityUrl);
  }

  public emitSelectSocialButton(name: string): void {
    this.selectSocialButton.emit(name);
  }

  public getMethod(button) {
    return button.name !== 'copy'
      ? this.emitSelectSocialButton(button.name)
      : this.copyLink(button.url);
  }

  public getUrl(button) {
    return button.name !== 'copy' ? button.url : null;
  }
}
